import { Box, Grid, Heading, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { FEATURES } from 'const';

export const Features: React.FC = () => {
  return (
    <Box py={16} id="features">
      <VStack>
        <VStack textAlign="center">
          <Heading size="xl">Niyə CaspiPos?</Heading>
          <Text fontSize="lg" color="gray.600" maxW="600px">
            Biznesinizi daha səmərəli idarə etmək üçün lazım olan hər şey
          </Text>
        </VStack>

        <Grid
          templateColumns={{
            base: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)'
          }}
          gap={8}
          w="100%"
        >
          {FEATURES.map((feature, index) => (
            <VStack
              key={index}
              align="start"
              p={6}
              bg="white"
              borderRadius="xl"
              border="1px solid"
              borderColor="gray.200"
              transition="all 0.3s"
              _hover={{
                shadow: 'lg',
                transform: 'translateY(-4px)'
              }}
            >
              <Box fontSize="3xl">{feature.icon}</Box>
              <Heading size="md">{feature.title}</Heading>
              <Text color="gray.600">{feature.description}</Text>
            </VStack>
          ))}
        </Grid>
      </VStack>
    </Box>
  );
};
